const DEFAULT_USER_PIC = '/assets/og_icons/UserDefault.svg'

const PROFILE_DETAIL_CARD_CONST = {
  DEFAULT_USER_PIC,
}

export default PROFILE_DETAIL_CARD_CONST
